<template>
  <div class="prizesComponent" v-if="prizeList.length">
    <ul class="box">
      <li v-for="item in prizeList" :key="item.activityPrizeId" @click="goToPrizePage">
        <img :src="item.prizePicture" alt="">
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';

export default {
  props: {
    activityInfo: {
      type: Object,
    },
  },
  data() {
    return {
      prizeList: [],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    detailData() {
      const { pullNewActivityPrizeDataList } = this.activityInfo;
      this.prizeList = pullNewActivityPrizeDataList ?? [];
    },
    goToPrizePage() {
      // 判断是否登录
      if (this.userInfo.id) {
        this.$router.push({
          path: '/pullnew/prize',
          query: {
            activityId: this.activityInfo.activityId,
          },
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('login');
      } else if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();

          params.forEach((item) => {
            const [key, value] = item.split('=');
            console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
        } else {
          url = `${domain}`
        }
        const redirctUrl = encodeURIComponent(`/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`);
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
      } else {
        const { path, query } = this.$route;
        this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
      }
    },
  },
  mounted() {
    this.detailData();
  },
};
</script>
<style scoped lang="scss">
.prizesComponent {
  width: 686px;
  height: 392px;
  margin: 48px auto;
  padding: 110px 40px 50px;
  background: url('../../../assets/img/pullNew/prizesBg.png') no-repeat;
  background-size: 100% auto;

  .box {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    overflow-x: scroll;
    overflow-y: hidden;

    li {
      flex-shrink: 0;
      width: 228px;
      height: 228px;
      margin-right: 24px;
      background: url('../../../assets/img/pullNew/prizeItemBg.png') no-repeat;
      background-size: 100% auto;

      img {
        width: 100%;
        height: 100%;
        padding: 3px;
        border-radius: 38px;
      }
    }

    li:last-child {
      margin-right: 0;
    }
  }

  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
